import 'mapbox-gl/dist/mapbox-gl.css';
let APP = window.APP || {};
import mapboxgl from "mapbox-gl/dist/mapbox-gl.js";
APP.mapboxgl = mapboxgl;
APP.mapboxgl.accessToken = APP.config.mapboxAccessToken || '';
